(function(){
'use strict';

// scFundraisingCommitmentService will be the single source of truth for supporter update, registration update and commitment update
scFundraisingCommitmentService.$inject = ["$http", "scFundraisingPagesService"];
function scFundraisingCommitmentService($http, scFundraisingPagesService) {
  return {
    putFundraisingCommitment: function putFundraisingCommitment(commitmentData) {
      var fundraisingPageId = _.get(scFundraisingPagesService, 'active.current.id', null);

      return $http({
        method: 'PUT',
        url: '/frs-api/fundraising-pages/' + fundraisingPageId + '/commitment',
        loadingScope: true,
        data: commitmentData
      });
    }
  };
}

angular.module('classy').service('scFundraisingCommitmentService', scFundraisingCommitmentService);
})();